import { render, staticRenderFns } from "./CardSubTitle.vue?vue&type=template&id=5fd4f6cf&scoped=true"
import script from "./CardSubTitle.vue?vue&type=script&lang=js"
export * from "./CardSubTitle.vue?vue&type=script&lang=js"
import style0 from "./CardSubTitle.vue?vue&type=style&index=0&id=5fd4f6cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd4f6cf",
  null
  
)

export default component.exports